// src/components/ReviewsCTA.js
import React from "react";

export default function ReviewsCTA({
  href,
  text = "Laisser un avis sur Google",
  className = "",
}) {
  // Valide doucement l'URL (sans jamais throw)
  const parsed = (() => {
    try {
      if (!href) return null;
      const u = new URL(href, window.location.origin);
      return /^https?:$/.test(u.protocol) ? u.toString() : null;
    } catch {
      return null;
    }
  })();

  // Fallback si href invalide/absent : renvoie vers la recherche Google de la fiche
  const fallback =
    "https://www.google.com/search?q=HLBK+Photographe+Tomblaine#reviews";

  const finalHref = parsed || fallback;

  return (
    <div className={`reviews-cta t-cta ${className}`} style={{ textAlign: "center", marginTop: 20 }}>
      <a
        href={finalHref}
        target="_blank"
        rel="noreferrer"
        className="t-cta-btn"
        aria-label={text}
      >
        ★ {text}
      </a>
      {!parsed && (
        <p style={{ marginTop: 6, fontSize: 12, opacity: 0.7 }}>
          (Redirection vers la page Google si le lien direct n’est pas disponible)
        </p>
      )}
    </div>
  );
}